import ReactGA from "react-ga4";
import { clearGoogleAnalyticsCookies } from "./consent";

const GA4_MEASUREMENT_ID = "G-DN716NQJPC";
const THIRTEEN_MONTHS_IN_SECONDS = 34128000;

let analyticsInitialized = false;

export const initializeAnalytics = () => {
  if (analyticsInitialized) return;

  ReactGA.initialize(GA4_MEASUREMENT_ID, {
    gaOptions: {
      allowAdFeatures: false,
      allowAdPersonalizationSignals: false,
      cookieExpires: THIRTEEN_MONTHS_IN_SECONDS,
      cookieUpdate: false,
    },
    gtagOptions: {
      anonymize_ip: true,
      send_page_view: false,
    },
  });
  analyticsInitialized = true;
};

export const sendPageView = (path) => {
  if (!analyticsInitialized) return;
  ReactGA.send({ hitType: "pageview", page: path });
};

export const disableAnalytics = () => {
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      analytics_storage: "denied",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });
  }

  clearGoogleAnalyticsCookies();
  document
    .querySelectorAll('script[src*="googletagmanager.com/gtag/js"]')
    .forEach((script) => script.remove());

  ReactGA.reset();
  analyticsInitialized = false;
  delete window.gtag;
  delete window.dataLayer;
};
